import { updateKeyInStore } from 'App';
import * as Yup from 'yup';
import { store } from 'app/redux/store';

import {
  SaleOfOtherAssetsStateValues,
  updateKey,
  updateFieldArrayKey,
} from './slice';
import { requiredFiles } from '../../useValidateQuestionnaire';

export const fields: IBaseField<keyof SaleOfOtherAssetsStateValues | any>[] = [
  {
    name: 'didYouHaveIncomeFromSalesOfOtherAssetsThisYear',
    label: 'Did you have income from sales of other assets this year?',
    type: 'radio',
    effect: updateKeyInStore(updateKey),
    tooltip: '',
    comment: true,
    dependencies: [
      {
        name: 'listOfAssets',
        label: 'List of Assets',
        type: 'fieldArray',
        dependencies: [
          {
            name: 'descriptionOfAsset',
            label: 'Description of asset',
            type: 'text',
            effect: updateKeyInStore(updateKey),
            tooltip: '',
            comment: true,
          },
          {
            name: 'dateAcquired',
            label: 'Date acquired',
            type: 'date',
            effect: updateKeyInStore(updateKey),
            tooltip: '',
            comment: true,
          },
          {
            name: 'acquisitionCost',
            label: 'Acquisition cost',
            type: 'number',
            effect: updateKeyInStore(updateKey),
            tooltip: '',
            comment: true,
          },
          {
            name: 'dateSold',
            label: 'Date sold',
            type: 'date',
            effect: updateKeyInStore(updateKey),
            tooltip: '',
            comment: true,
          },
          {
            name: 'amountOfSale',
            label: 'Amount of sale',
            type: 'number',
            effect: updateKeyInStore(updateKey),
            tooltip: '',
            comment: true,
          },
        ],
        defaultDependency: {},
        effect: (payload) => store.dispatch(updateFieldArrayKey(payload)),
        predicate: (v) => v === 'yes',
        comment: true,
      },
      {
        name: 'doYouHaveAClosingStatementOrOtherDocumentationOfTheSale',
        label:
          'Do you have a closing statement or other documentation of the sale?',
        type: 'radio',
        effect: updateKeyInStore(updateKey),
        predicate: (v) => v === 'yes',

        comment: true,
        dependencies: [
          {
            name: 'pleaseUploadAClosingStatementOrOtherDocumentationOfTheSale',
            label:
              'Please upload a closing statement or other documentation of the sale.',
            type: 'upload',
            effect: updateKeyInStore(updateKey),

            comment: true,
            predicate: (v) => v === 'yes',
          },
        ],
      },
    ],
  },
];

export const validationSchema = Yup.object().shape({});
